const subscriptionPlansNorwegian = {
  header: {
    title: "Velg din plan",
    description: "Få tilgang til alle funksjoner og start med å øke din LinkedIn-tilstedeværelse i dag."
  },
  trial: {
    title: "14 dagers gratis prøveperiode",
    subtitle: "Ingen binding - si opp når som helst"
  },
  billing: {
    monthly: "Månedlig",
    yearly: "Årlig",
    savingsLabel: "Spar 17%"
  },
  currency: {
    dkk: "DKK",
    usd: "USD"
  },
  plans: {
    basic: "Basic"
  },
  pricing: {
    perMonth: "måned",
    perYear: "år",
    monthly: "måned",
    yearly: "år"
  },
  quantity: {
    label: "Antall lisenser:",
    seatsInfo: "Hver lisens gir tilgang til 1 bruker"
  },
  summary: {
    total: "Totalt:",
    checkoutButton: "Start gratis prøveperiode"
  },
  errors: {
    checkoutError: "Det oppstod en feil ved opprettelse av checkout-økt. Prøv igjen senere."
  }
};

export default subscriptionPlansNorwegian;
